export default "__VITE_ASSET__DEsGTDYL__"